import React, { useState } from 'react';
import './App.css';
import {
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt,
  FaInstagram,
  FaFacebook,
  FaTiktok
} from 'react-icons/fa';
import CustomDropdown from './components/CustomDropdown';

function App() {
  const propertySizeOptions = [
    { label: 'Studio', value: 'Studio' },
    { label: '1 Bedroom', value: '1 Bedroom' },
    { label: '2 Bedrooms', value: '2 Bedrooms' },
    { label: '3 Bedrooms', value: '3 Bedrooms' },
    { label: 'Shop', value: 'Shop' },
    { label: 'Town house', value: 'Townhouse' }
  ];

  const cityOptions = [
    { label: 'Dubai', value: 'Dubai' },
    { label: 'Abu Dhabi', value: 'Abu Dhabi' },
    { label: 'Sharjah', value: 'Sharjah' },
    { label: 'Ras Al-Khaimah', value: 'Ras Al-Khaimah' }
  ];

  const maxPricesOptions = [
    { label: 'Any', value: 'Any' },
    { label: 'AED 500,000', value: 'AED 500,000' },
    { label: 'AED 750,000', value: 'AED 750,000' },
    { label: 'AED 1,000,000', value: 'AED 1,000,000' },
    { label: 'AED 3,000,000', value: 'AED 3,000,000' },
    { label: 'AED 5,000,000', value: 'AED 5,000,000' },
    { label: 'AED 10,000,000', value: 'AED 10,000,000' }
  ];

  const propertyStatusOptions = [
    { label: 'All', value: 'All' },
    { label: 'Off Plan', value: 'Off Plan' },
    { label: 'Ready', value: 'Ready' }
  ];

  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    propertyType: '',
    propertyStatus: 'All',
    maxPrice: '',
    city: ''
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const FORMSPREE_URL = "https://formspree.io/f/mwvvvvow";

    const response = await fetch(FORMSPREE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setStatus("SUCCESS");
      setFormData({ email: '', phone: '', propertyType: '', propertyStatus: 'All', maxPrice: '', city: '' }); // Clear form
    } else {
      setStatus("ERROR");
    }
  };

  const handleStatusChange = (status) => {
    setFormData({ ...formData, propertyStatus: status });
  };

  return (
    <div className="linktree-container">
      <div className="content-wrapper">
        {/* Profile Header */}
        <header className="profile-header">
          <img src="gm-photo.jpg" alt="Logo" className="profile-pic" />
          <h1>GM1.RealEstate</h1>
          <p className="bio">Premier Real Estate Agent | Luxury Properties</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/gm1.realestate?igsh=N2lqM2kzNDh1dWp3&utm_source=qr" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://www.facebook.com/share/1WFSitVwXE/?mibextid=wwXIfr" target="_blank" rel="noreferrer"><FaFacebook /></a>
            <a href="https://www.tiktok.com/@gm1.realestate?_r=1&_t=ZS-932MT7DeRF3" target="_blank" rel="noreferrer"><FaTiktok /></a>
          </div>
        </header>

        {/* Action Buttons (Linktree style) */}
        <div className="link-stack">
          {/* <a href="tel:+971552558078" className="tree-link">
            <FaPhoneAlt className="icon" /> Call Me
          </a> */}
          <a href="mailto:gm1.realestate@hotmail.com" className="tree-link">
            <FaEnvelope className="icon" /> Email Me
          </a>
        </div>

        {/* The Lead Form */}
        <div className="form-section">
          <h2 className="section-title">Looking for Your Perfect Property?</h2>
          {status === "SUCCESS" ? (
            <div className="success-msg">
              <h3>Thank you!</h3>
              <p>I have received your info and will contact you shortly.</p>
              <button onClick={() => setStatus("")} className="tree-submit">Send another?</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="tree-form">
              <div className="form-group-stack">
                <div className="status-selector-container">
                  <div className="status-button-group">
                    {propertyStatusOptions.map((status) => (
                      <button
                        key={status.value}
                        type="button" // Important: prevents form submission on click
                        className={`status-btn ${formData.propertyStatus === status.value ? 'active' : ''}`}
                        onClick={() => handleStatusChange(status.value)}
                      >
                        {status.label}
                      </button>
                    ))}
                  </div>
                </div>

                <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
                <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />

                <CustomDropdown
                  name="propertyType"
                  placeholder="Property Type"
                  options={propertySizeOptions}
                  value={formData.propertyType}
                  onChange={handleChange}
                />

                <CustomDropdown
                  name="maxPrice"
                  placeholder="Max Price"
                  options={maxPricesOptions}
                  value={formData.maxPrice}
                  onChange={handleChange}
                />

                <CustomDropdown
                  name="city"
                  placeholder="City"
                  options={cityOptions}
                  value={formData.city}
                  onChange={handleChange}
                />
              </div>
              <input type="hidden" name="_subject" value="New Real Estate Lead - Inquiry Form" />
              <input type="text" name="_gotcha" className="hidden-field" />
              <button type="submit" className="tree-submit">
                {status === "ERROR" ? "Try Again" : "Submit Inquiry"}
              </button>
            </form>
          )}
        </div>
      </div>

      <a href="https://wa.me/+971552558078?text=Hello,%20I%20am%20interested%20in%20real%20estate!" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp size={28} />
      </a>
    </div>
  );
}

export default App;